import * as URL from './url';
import axios from './axios';
// 获取banner
export async function getBannerList(data, options = {}) {
    return axios({
        url: URL.getBannerList,
        method: 'post',
        data,
        ...options,
    });
}
// 获取新闻列表
export async function getNewsList(data, options = {}) {
    return axios({
        url: URL.getNewsList,
        method: 'post',
        data,
        ...options,
    });
}
// 获取新闻详情
export async function getNewsDetail(data, options = {}) {
    return axios({
        url: URL.getNewsDetail,
        method: 'post',
        data,
        ...options,
    });
}
// 获取footer链接
export async function getPageLinks(data, options = {}) {
    return axios({
        url: URL.getPageLinks,
        method: 'post',
        data,
        ...options,
    });
}
// 获取配置
export async function getConfigObj(data, options = {}) {
    return axios({
        url: URL.getConfigObj,
        method: 'post',
        data,
        ...options,
    });
}
// 用户注册
export async function userRegister(data, options = {}) {
    return axios({
        url: URL.userRegister,
        method: 'post',
        data,
        ...options,
    });
}
// 短信验证码
export async function getImageCode(data, options = {}) {
    return axios({
        url: URL.userGetCheckCode,
        method: 'post',
        data,
        ...options,
    });
}
// 短信验证码
export async function getCode(data, options = {}) {
    return axios({
        url: URL.userGetCode,
        method: 'post',
        data,
        ...options,
    });
}
// 找回密码
export async function userFindPassword(data, options = {}) {
    return axios({
        url: URL.userFindPassword,
        method: 'post',
        data,
        ...options,
    });
}
// 用户登录
export async function userLogin(data, options = {}) {
    //data["password"] = md5(data["password"]);
    return axios({
        url: URL.userLogin,
        method: 'post',
        data,
        ...options,
    });
}
// 账号管理
export async function accountProfile(data, options = {}) {
    return axios({
        url: URL.accountProfile,
        method: 'post',
        data,
        ...options,
    });
}
// 搜索
export async function searchResults(data, options = {}) {
    return axios({
        url: URL.searchResults,
        method: 'post',
        data,
        ...options,
    });
}
// 获奖作品
export async function winWorks(data, options = {}) {
    return axios({
        url: URL.winWorks,
        method: 'post',
        data,
        ...options,
    });
}
// 用户信息
export async function getUserInfo(data, options = {}) {
    return axios({
        url: URL.getUserInfo,
        method: 'post',
        data,
        ...options,
    });
}
// 获取用户作品
export async function getUserWorks(data, options = {}) {
    return axios({
        url: URL.getUserWorks,
        method: 'post',
        data,
        ...options,
    });
}
// 删除用户作品
export async function delUserWorks(data, options = {}) {
    return axios({
        url: URL.delUserWorks,
        method: 'post',
        data,
        ...options,
    });
}
// 提交用户作品
export async function submitUserWorks(data, options = {}) {
    return axios({
        url: URL.submitUserWorks,
        method: 'post',
        data,
        ...options,
    });
}
// 更新头像
export async function updateAv(data, options = {}) {
    return axios({
        url: URL.updateAv,
        method: 'post',
        data,
        ...options,
    });
}
// 获取作品详情
export async function getWorksDetail(data, options = {}) {
    return axios({
        url: URL.getWorksDetail,
        method: 'post',
        data,
        ...options,
    });
}
export async function winWorksDetail(data, options = {}) {
    return axios({
        url: URL.winWorksDetail,
        method: 'post',
        data,
        ...options,
    });
}
export async function getRace(data, options = {}) {
    return axios({
        url: URL.getRace,
        method: 'post',
        data,
        ...options,
    });
}
export async function getRaceTopic(data, options = {}) {
    return axios({
        url: URL.getRaceTopic,
        method: 'post',
        data,
        ...options,
    });
}
export async function getRaceTopicByGroup(data, options = {}) {
    return axios({
        url: URL.getRaceTopicByGroup,
        method: 'post',
        data,
        ...options,
    });
}
export async function getRaceTopicInfo(data, options = {}) {
    return axios({
        url: URL.getRaceTopicInfo,
        method: 'post',
        data,
        ...options,
    });
}
export async function getDistrict(data, options = {}) {
    return axios({
        url: URL.getDistrict,
        method: 'post',
        data,
        ...options,
    });
}
export async function getAwardList(data, options = {}) {
    return axios({
        url: URL.getAwardList,
        method: 'post',
        data,
        ...options,
    });
}
export async function getMyWorksShow(data, options = {}) {
    return axios({
        url: URL.getMyWorksShow,
        method: 'post',
        data,
        ...options,
    });
}
export async function editUserWorks(data, options = {}) {
    return axios({
        url: URL.editUserWorks,
        method: 'post',
        data,
        ...options,
    });
}
export async function getRaceInfo(data, options = {}) {
    return axios({
        url: URL.getRaceInfo,
        method: 'post',
        data,
        ...options,
    });
}
export async function getSearchSchoolFilter(data, options = {}) {
    return axios({
        url: URL.getSearchSchoolFilter,
        method: 'post',
        data,
        ...options,
    });
}
